import get from 'lodash/get';
import { useState, useEffect } from 'react';

import { AudiencesReference } from 'src/actions/audiences/audiencesReferencesResource';
import audiencesReferencesResource from 'src/actions/audiences/audiencesReferencesResource';
import useDocumentResource from 'src/presentation/hooks/useDocumentResource';
import { STATUS_SUCCEEDED, STATUS_UNSTARTED } from 'src/presentation/hooks/useResource';

const useAudiencesReference = ({ item }) => {
  const { id } = item;
  const [references, setReferences] = useState<AudiencesReference[]>([]);
  const [loadingState, setLoadingState] = useState<string>(STATUS_UNSTARTED);

  const { value: referencesDto, loadingStates: referencesLoadingStates } = useDocumentResource(
    audiencesReferencesResource,
    { fetch: true, params: { id } }
  );
  useEffect(() => {
    if (referencesLoadingStates[id] === STATUS_SUCCEEDED) {
      setReferences(get(referencesDto, id));
    }
    setLoadingState(referencesLoadingStates[id]);
  }, [id, referencesDto, referencesLoadingStates, setReferences]);

  return { references, loadingState };
};

export default useAudiencesReference;
